define.alias("shared/helpers/json-stringify", "settings/helpers/json-stringify");